import React, { useEffect, useState } from "react";
import { Input } from "reactstrap";
import Select from "react-select";
import { connect } from "react-redux";
import { setBreadcrumbItems } from "../../store/actions";
import Spinners from "components/Common/Spinner";
import * as url from "../../helpers/url_helper";
import "flatpickr/dist/themes/material_blue.css";
import { Link, useNavigate, useParams } from "react-router-dom";
import moment from "moment";
import { toast } from "react-toastify";
import Flatpickr from "react-flatpickr";

const NewMeeting = (props) => {
  const { id } = useParams();
  document.title = id ? "Edit Schedule" : "New Schedule";
  const [isLoading, setLoading] = useState(false);
  const [locationsOptions, setLocationsOptions] = useState([]);
  const navigate = useNavigate();
  const breadcrumbItems = [
    { title: "VUF", link: "#" },
    { title: id ? "Edit Schedule" : "New Schedule", link: "#" },
  ];
  useEffect(() => {
    props.setBreadcrumbItems(
      id ? "Edit Schedule" : "New Schedule",
      breadcrumbItems
    );
  });
  useEffect(() => {
    if (id !== "" && id != null && id != undefined) {
      getSchedule();
    }
    getLocation();
  }, [id]);

  const statusOptions = [
    { label: "Upcoming", value: "Upcoming" },
    { label: "Ongoing", value: "Ongoing" },
    ...(id ? [{ label: "Cancelled", value: "Cancelled" }] : []),
  ];
  const scheduleOptions = [
    {
      label: "Once",
      value: "Once",
    },
    {
      label: "Daily",
      value: "Daily",
    },
    {
      label: "Weekly",
      value: "Weekly",
    },
    {
      label: "AlternateDay",
      value: "AlternateDay",
    },
  ];

  const [state, setState] = useState({
    loading: false,
    errors: {},
    ResErrors: {},
    title: "",
    description: "",
    start_date: "",
    end_date: "",
    start_time: "",
    end_time: "",
    schedule_status: "",
    schedule_type: "",
    locationId: "",
  });

  function handleValidation() {
    let errors = {};
    let formIsValid = true;

    if (state.title?.trim() === "") {
      formIsValid = false;
      errors.title = "Please enter title";
    }
    if (state.description?.trim() === "") {
      formIsValid = false;
      errors.description = "Please enter description";
    }
    if (state.start_date === "") {
      formIsValid = false;
      errors.start_date = "Please select start date";
    }
    if (state.end_date === "") {
      formIsValid = false;
      errors.end_date = "Please enter end date";
    }
    if (state.start_time === "") {
      formIsValid = false;
      errors.start_time = "Please enter start time";
    }
    if (state.end_time === "") {
      formIsValid = false;
      errors.end_time = "Please enter end time";
    }
    if (state.schedule_status === "") {
      formIsValid = false;
      errors.schedule_status = "Please enter schedule status";
    }
    if (state.schedule_type === "") {
      formIsValid = false;
      errors.schedule_type = "Please select schedule type";
    }

    setState((prevState) => ({
      ...prevState,
      errors: errors,
    }));

    return formIsValid;
  }
  function getSchedule() {
    setLoading(true);
    let urlPath = "schedule/details/" + id;

    fetch(url.VUF_APP_API + urlPath, {
      method: "GET",
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
      },
    })
      .then((response) => response.json())
      .then((responseData) => {
        if (responseData.status) {
          var dataRes = responseData.response;

          setState((prevState) => ({
            ...prevState,
            title: dataRes.scheduleDetails.title,
            description: dataRes.scheduleDetails.description,
            start_time: dataRes.scheduleDetails.start_time,
            end_time: dataRes.scheduleDetails.end_time,
            start_date: moment(dataRes.start_date).format("YYYY-MM-DD"),
            end_date: moment(dataRes.end_date).format("YYYY-MM-DD"),
            schedule_status: dataRes.scheduleDetails.schedule_status,
            schedule_type: dataRes.scheduleDetails.schedule_type,
            locationId: dataRes.scheduleDetails.locationId,
          }));
        } else {
          toast.error("Something went wrong, Please try again after sometime.");
        }
        setLoading(false);
      })
      .catch((error) => {
        console.log("err", error);
        toast.error("Something went wrong, Please try again after sometime.");
        // setState({ loading: false });
      })
      .finally((final) => {
        // return setState({ isInvitingUser: false })
      });
  }
  function onNewMeeting(e) {
    if (!handleValidation()) {
      return false;
    }
    let urlPath, dataMethod;
    if (id) {
      urlPath = `schedule/update-schedule/${id}`;
      dataMethod = "PUT";
    } else {
      urlPath = "schedule/create";
      dataMethod = "POST";
    }
    setLoading(false);
    fetch(url.VUF_APP_API + urlPath, {
      method: dataMethod,
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
      },
      body: JSON.stringify({
        title: state.title,
        description: state.description,
        start_date: state.start_date,
        start_time: state.start_time,
        end_date: state.end_date,
        end_time: state.end_time,
        schedule_status: id
          ? state.schedule_status
          : state.schedule_status.value,
        schedule_type: id ? state.schedule_type : state.schedule_type.value,
        locationId: id ? state.locationId : state.locationId.value,
      }),
    })
      .then((response) => response.json())
      .then((responseData) => {
        toast.success(responseData.message);
        if (responseData.status) {
          setTimeout(() => {
            navigate("/Meeting");
          }, 1000);
        } else {
          toast.error(responseData.message);
        }
      })
      .catch((error) => {
        console.error("Error:", error);
        alert("Something went wrong, please try again.");
      })
      .finally((final) => {
        setLoading(false);
      });
  }
  function getLocation() {
    setLoading(true);
    let urlPath = "location/locationList/";
    fetch(url.VUF_APP_API + urlPath, {
      method: "GET",
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
      },
    })
      .then((response) => response.json())
      .then((responseData) => {
        if (responseData.status) {
          var locationData = responseData.data;
          const locationOption = locationData.map((location, index) => {
            return {
              label: location.name,
              value: location._id,
            };
          });
          setLocationsOptions(locationOption);
        } else {
          toast.error("Something went wrong, Please try again after sometime.");
        }
        setLoading(false);
      })
      .catch((error) => {
        console.log("err", error);
        toast.error("Something went wrong, Please try again after sometime.");
        // setState({ loading: false });
      })
      .finally((final) => {
        // return setState({ isInvitingUser: false })
      });
  }
  return (
    <React.Fragment>
      {isLoading ? (
        <Spinners />
      ) : (
        <>
          <div className="container" style={{ maxWidth: "100%" }}>
            <div className="row">
              <div className="col-lg-12">
                <div
                  className="card card-custom gutter-b example example-compact"
                  style={{ borderRadius: "20px" }}
                >
                  <div className="card-body row col-12">
                    <h3 className="mb-4">
                      {id ? `Edit Schedule - ${state.title}` : "New Schedules"}
                    </h3>
                    <form>
                      <div className="row">
                        <div className="col-md-3">
                          <div className="form-group">
                            <label for="name">Schedule Title</label>
                            <Input
                              type="text"
                              name="eventName"
                              className="form-control form-control-solid"
                              placeholder="Enter Title"
                              onChange={(event) =>
                                setState((prevState) => ({
                                  ...prevState,
                                  title: event.target.value,
                                }))
                              }
                              value={state.title}
                            />
                            <span className="form-text text-danger">
                              {state.errors?.title}
                            </span>
                          </div>
                        </div>
                        <div className="col-md-3">
                          <div className="form-group">
                            <label for="desc">Description</label>
                            <Input
                              type="text"
                              className="form-control form-control-solid"
                              placeholder="Enter Description"
                              onChange={(event) =>
                                setState((prevState) => ({
                                  ...prevState,
                                  description: event.target.value,
                                }))
                              }
                              value={state.description}
                            />
                            <span className="form-text text-danger">
                              {state.errors?.description}
                            </span>
                          </div>
                        </div>
                        <div className="col-md-6">
                          <div className="form-group">
                            <label for="desc">Location</label>
                            {id ? (
                              <Select
                                options={locationsOptions}
                                value={locationsOptions.find(
                                  (opt) => opt.value === state.locationId
                                )}
                                onChange={(event) => {
                                  setState((prevState) => ({
                                    ...prevState,
                                    locationId: event.value,
                                  }));
                                }}
                              />
                            ) : (
                              <Select
                                options={locationsOptions}
                                value={state.locationId}
                                onChange={(selectedOption) => {
                                  setState((prevState) => ({
                                    ...prevState,
                                    locationId: selectedOption,
                                  }));
                                }}
                              />
                            )}
                            <span className="form-text text-danger">
                              {state.errors?.location}
                            </span>
                          </div>
                        </div>
                      </div>
                      <div className="row">
                        <div className="col-md-3">
                          <div className="form-group">
                            <label for="startDate">Start Date</label>
                            <Flatpickr
                              value={state.start_date}
                              onChange={(selectedDates) => {
                                const newStartDate = selectedDates[0];
                                setState((prevState) => ({
                                  ...prevState,
                                  start_date: newStartDate,
                                  end_date:
                                    prevState.end_date &&
                                    prevState.end_date < newStartDate
                                      ? null
                                      : prevState.end_date,
                                }));
                              }}
                              options={{
                                minDate: state.start_date || "today",
                                dateFormat: "Y-m-d",
                              }}
                              className="form-control"
                              placeholder="Select Start Date"
                            />
                            <span className="form-text text-danger">
                              {state.errors?.start_date}
                            </span>
                          </div>
                        </div>
                        <div className="col-md-3">
                          <div className="form-group">
                            <label for="startTime">Start Time</label>
                            <Flatpickr
                              onChange={([date]) => {
                                const formattedTime = date.toLocaleTimeString(
                                  [],
                                  {
                                    hour: "2-digit",
                                    minute: "2-digit",
                                    hour12: false,
                                  }
                                );

                                setState((prev) => ({
                                  ...prev,
                                  start_time: formattedTime,
                                }));
                              }}
                              value={state.start_time}
                              options={{
                                enableTime: true,
                                noCalendar: true,
                                dateFormat: "H:i",
                              }}
                              className="form-control"
                              placeholder="Select Start Time"
                            />
                            <span className="form-text text-danger">
                              {state.errors?.start_time}
                            </span>
                          </div>
                        </div>
                        <div className="col-md-3">
                          <div className="form-group">
                            <label for="endDate">End Date</label>
                            <Flatpickr
                              value={state.end_date}
                              onChange={(selectedDates) => {
                                setState((prevState) => ({
                                  ...prevState,
                                  end_date: selectedDates[0],
                                }));
                              }}
                              options={{
                                minDate: state.start_date || "today",
                                dateFormat: "Y-m-d",
                              }}
                              className="form-control"
                              placeholder="Select End Date"
                              disabled={!state.start_date}
                            />
                            <span className="form-text text-danger">
                              {state.errors?.end_date}
                            </span>
                          </div>
                        </div>
                        <div className="col-md-3">
                          <div className="form-group">
                            <label for="endTime">End Time</label>
                            <Flatpickr
                              value={state.end_time}
                              onChange={(selectedTime) => {
                                const time = selectedTime[0];

                                if (time) {
                                  const formattedTime = time.toLocaleTimeString(
                                    [],
                                    {
                                      hour: "2-digit",
                                      minute: "2-digit",
                                      hour12: false,
                                    }
                                  );

                                  setState((prev) => ({
                                    ...prev,
                                    end_time: formattedTime,
                                  }));
                                }
                              }}
                              options={{
                                enableTime: true,
                                noCalendar: true,
                                dateFormat: "H:i",
                              }}
                              className="form-control"
                              placeholder="Select End Time"
                            />
                            <span className="form-text text-danger">
                              {state.errors?.end_time}
                            </span>
                          </div>
                        </div>
                      </div>
                      <div className="row">
                        <div className="col-md-6">
                          <div className="form-group">
                            <label for="endTime">Status</label>
                            {!id ? (
                              <Select
                                options={statusOptions}
                                value={state.schedule_status}
                                onChange={(selectedOption) =>
                                  setState({
                                    ...state,
                                    schedule_status: selectedOption,
                                  })
                                }
                              />
                            ) : (
                              <Select
                                options={statusOptions}
                                value={statusOptions.find(
                                  (o) => o.value === state.schedule_status
                                )}
                                onChange={(selectedOption) =>
                                  setState({
                                    ...state,
                                    schedule_status: selectedOption.value,
                                  })
                                }
                              />
                            )}
                            <span className="form-text text-danger">
                              {state.errors?.schedule_status}
                            </span>
                          </div>
                        </div>
                        <div className="col-md-6">
                          <div className="form-group">
                            <label for="endTime">Schedule Type</label>
                            {id ? (
                              <Select
                                options={scheduleOptions}
                                value={scheduleOptions.find(
                                  (o) => o.value === state.schedule_type
                                )}
                                onChange={(selectedOption) =>
                                  setState({
                                    ...state,
                                    schedule_type: selectedOption.value,
                                  })
                                }
                              />
                            ) : (
                              <Select
                                options={scheduleOptions}
                                value={state.schedule_type}
                                onChange={(selectedOption) =>
                                  setState({
                                    ...state,
                                    schedule_type: selectedOption,
                                  })
                                }
                              />
                            )}
                            <span className="form-text text-danger">
                              {state.errors?.schedule_type}
                            </span>
                          </div>
                        </div>
                      </div>
                      <div className="col-md-4">
                        <div
                          className="form-group"
                          style={{
                            justifyContent: "center",
                            alignItems: "center",
                          }}
                        >
                          <button
                            type="button"
                            className="btn btn-outline-primary me-3"
                            onClick={(event) => onNewMeeting(event)}
                          >
                            {id ? "Update Schedule" : "New Schedule"}
                          </button>
                          <Link
                            to={"/Meeting"}
                            className="btn btn-outline-danger"
                          >
                            Cancel
                          </Link>
                        </div>
                      </div>
                    </form>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </>
      )}
    </React.Fragment>
  );
};

export default connect(null, { setBreadcrumbItems })(NewMeeting);
